import { render, staticRenderFns } from "./aRoomDetailHisFee.vue?vue&type=template&id=88e83118&scoped=true"
import script from "./aRoomDetailHisFee.vue?vue&type=script&lang=js"
export * from "./aRoomDetailHisFee.vue?vue&type=script&lang=js"
import style0 from "./aRoomDetailHisFee.vue?vue&type=style&index=0&id=88e83118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e83118",
  null
  
)

export default component.exports